// src/components/Theme1Provider.js
import React, { createContext, useMemo, useState, useEffect } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

export const ColorModeContext = createContext();

export default function Theme1Provider({ children }) {
  const [mode, setMode] = useState("light");

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () =>
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light")),
      // 👇 Añadir esta línea
      setMode: (mode) => setMode(mode),
    }),
    []
  );

  // 🔁 Actualiza el atributo 'data-theme' en el <body> al cambiar el modo
  useEffect(() => {
    document.body.setAttribute("data-theme", mode);
  }, [mode]);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          ...(mode === "light"
            ? {
                primary: { main: "#00c2a3" },
                secondary: { main: "#90b2b7" },
                third: { main: "#00c2a254" },
                caja: { main: "#f1f1f1" },
                cfazul: { main: "#a8ddf3ff" },
                cfazul1: { main: "#d0ecf8ff" },
                cfverde: { main: "#d2fad4ff" },
                cfverde1: { main: "#d3ffd6ff" },
                cfvnaranja: { main: "#fcccb2ff" },
                cfvnaranja1: { main: "#fde2d3ff" },
                estimates: { main: "#f3f7f7" },
                text: {
                  primary: "#000000",
                  secondary: "#000",
                  tercero: "#000",
                  cuarto: "#000",
                  quinto: "#ffac7e",
                },
                cashFlow: "#ebeeee",

                pyg: "#444444",
                pyg1: "#d0ecf8ff",
                pyg2: "#ccc",
                PedCompra: "#e0413bff",
                cfdia: "#ffe5e0",
                cfacum: "#e0ffe5",
                background: {
                  default: "#f4f4f4", // 👈 color claro
                  paper: "#fff",
                },
                gant: { main: "#e0e0e0" },
                ganttext: { main: "#4d0303ff" },
              }
            : {
                primary: { main: "#90b2b7" },
                secondary: { main: "#00c2a3" },
                third: { main: "#67b1925d" },
                caja: { main: "#2a2a2a" },
                cfazul: { main: "#80c6e4ff" },
                cfazul1: { main: "#8ed5f3ff" },
                cfverde: { main: "#acf8b0ff" },
                cfverde1: { main: "#427745ff" },
                cfvnaranja: { main: "#fc9d6aff" },
                cfvnaranja1: { main: "#836250ff" },
                estimates: { main: "#1e1e1e" },
                text: {
                  primary: "#ffffff",
                  secondary: "#aaaaaa",
                  tercero: "#ffac7e",
                  cuarto: "#90b2b7",
                  quinto: "#90b2b7",
                },
                cashFlow: "#5c7275",
                pyg: "#cccccc",
                pyg1: "#5c7275",
                pyg2: "#460d0dff",
                PedCompra: "#4b3030",
                cfdia: "#4b3030",
                cfacum: "#304b30",
                background: {
                  default: "#313131", // 👈 este se sobreescribe con CssBaseline abajo
                  paper: "#1e1e1e",
                  cajaInpunts: "#181818",
                },
                gant: { main: "#515151" },
                ganttext: { main: "#da5959ff" },
              }),
        },
        components: {
          MuiCssBaseline: {
            styleOverrides: {
              body: {
                backgroundColor: mode === "dark" ? "#313131" : "#f4f4f4", // 👈 fuerza
              },
            },
          },
        },
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
